<footer class="border-top bg-white">
  <div class="container-fluid py-2 px-3 d-flex justify-content-between text-muted small">
    <div>© {{ year }} HS Plus</div>
    <div>Build: {{ buildDate }}</div>
  </div>
</footer>
